import { Link } from '@mui/material';
import { Box, styled } from '@mui/system';
import { useTranslation } from 'react-i18next';

const OtherJoinOptionsWrapper = styled(Box)`
    display: flex;
    justify-content: center;
    margin-top: 1rem;
`;

// TODO: check why I made this a span
const OtherJoinOptionsText = styled('span')``;

const OtherJoinOptionsLink = styled(Link)`
    cursor: pointer;
    margin-right: 0.5rem;
`;

type OtherJoinOptionsProps = {
    backToStateUrl: () => void;
};
const OtherJoinOptions = (props: OtherJoinOptionsProps) => {
    const { backToStateUrl } = props;

    const { t } = useTranslation('sign-up');

    return (
        <OtherJoinOptionsWrapper>
            <OtherJoinOptionsLink
                onClick={() => {
                    backToStateUrl();
                }}
            >
                {t('go-back')}
            </OtherJoinOptionsLink>
            <OtherJoinOptionsText>{t('to-other-join-options')}</OtherJoinOptionsText>
        </OtherJoinOptionsWrapper>
    );
};
export default OtherJoinOptions;
